<template>
	<q-layout-header>
		<q-toolbar class="mobile-hide no-shadow" :style="getStyleDesktop">
			<q-toolbar-title>
				{{ $t('control_panel') }}
			</q-toolbar-title>

			<q-btn v-if="showHomeButton" flat dense :label="$t('home')" icon="fas fa-home" class="q-mr-md"
				@click="goToHome()" />

			<q-btn v-if="!showHomeButton" flat dense :label="$t('home')" icon="fas fa-home" class="q-mr-md"
				@click="goToHomeV2()" />

			<client />

			<country />

			<notification />

			<user-menu />

			<language />
		</q-toolbar>

		<q-toolbar class="desktop-hide" :style="getStyleMobile">
			<q-btn flat round dense @click="openMenu()" icon="fas fa-bars" />

			<q-toolbar-title>
				{{ $t('control_panel') }}
			</q-toolbar-title>

			<notification />
		</q-toolbar>
	</q-layout-header>
</template>

<script>
import { mapGetters } from 'vuex'
import { colors } from 'quasar'
import Notification from 'components/header/Notification'
import UserMenu from 'components/header/UserMenu'
import Language from 'components/header/Language'
import Country from 'components/header/Country'
import Client from 'components/header/Client'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'admin'] },

	components: {
		notification: Notification,
		language: Language,
		country: Country,
		'user-menu': UserMenu,
		client: Client,
	},

	data() {
		return {}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
			tmp_system_new_version: 'params/tmp_system_new_version',
		}),

		getTitle() {
			return this.$route.meta.title
		},

		showHomeButton() {
			return !this.tmp_system_new_version
		},

		getStyleMobile() {
			if (process.env.PROJECT_FOLDER === 'itpiry') return 'padding-top: 55px;'
			else return ''
		},

		getStyleDesktop() {
			if (process.env.PROJECT_FOLDER === 'itpiry') return 'margin-top: 70px;'
			else return ''
		},

		getHeader() {
			let headers = {}
			return headers = {
				headers: {
					'content-type': 'application/json',
					'authorization': 'Bearer ' + this.access_token
				}
			}
		},
	},

	methods: {
		openMenu() {
			this.$store.dispatch('common/SET_ADMIN_LEFT_MENU', [true])
		},

		goToHome() {
			let obj_redirect = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj_redirect) {
				if (obj_redirect.home_route) this.$router.replace({ name: obj_redirect.home_route })
				else this.$router.replace({ name: 'courses' })
			} else {
				this.$router.replace({ name: 'courses' })
			}
		},

		goToHomeV2() {
			if (process.env.SITE_URL) {
				const hostname = new URL(process.env.CONTROL_PANNEL_URL).hostname
				const domainToCookie = hostname.substring(hostname.indexOf('.'))
				this.$q.loading.show()

				this.$axios.get(`/etraining_login/tswap/`, this.getHeader)
					.then(response => {

						document.cookie = `at-v2=${response.data.access_token}; path=/; domain=${domainToCookie}; SameSite=Lax; Secure`
						window.open(
							`${process.env.SITE_URL}/login-redirect-v2/`
						)
					})
					.catch(e => {
						console.log(e)
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			}
		},
	},
}
</script>

<style></style>
